import PaymentMethod from './PaymentMethod';
import { ECardStep, EPaymentMethodTypes } from '@/helpers/enums';
import ICreditCardPaymentMethod from '@/interfaces/Methods/CreditCard';

export default class CreditCardPaymentMethod extends PaymentMethod implements ICreditCardPaymentMethod {
  type: EPaymentMethodTypes = EPaymentMethodTypes.creditCard;
  step: ECardStep = ECardStep.new;
  installment: {
    number: null;
    amount: null;
  };

  secondStep: ECardStep = ECardStep.new;
  secondInstallment: {
    number: null;
    amount: null;
  };

  constructor(method?: ICreditCardPaymentMethod) {
    super();

    this.build(method);
  }

  build(method?: ICreditCardPaymentMethod): CreditCardPaymentMethod {
    Object.assign(this, { ...method });

    return this;
  }
}
